import React from 'react'
import Typography from '@mui/material/Typography'
import ContentWithLogoGrid from 'proposals/components/layout/ContentWithLogoGrid'
import View from 'proposals/components/layout/View'
import Logo from 'proposals/components/Logo'
import PageTitle from 'proposals/components/PageTitle'
import Box from '@mui/material/Box'
import { useTranslation } from 'react-i18next'

const NotFoundView: React.FC = () => {
  const { t } = useTranslation()

  return (
    <View>
      <ContentWithLogoGrid>
        <Logo src="/images/error.png" />
        <PageTitle>
          <Typography sx={{ lineHeight: 1, fontWeight: 'fontWeightLight' }} variant="h3">
            {t('error-insufficient-link')}
          </Typography>
        </PageTitle>
        <Box sx={{ gridArea: 'content' }}>
          <Typography paragraph>{t('link-error-1')}</Typography>
          <Typography>{t('link-error-2')}</Typography>
          <Typography>{t('link-error-3')}</Typography>
          <Typography>{t('link-error-4')}</Typography>
          <Typography paragraph>{t('link-error-5')}</Typography>
          <Typography paragraph>{t('link-error-6')}</Typography>
          <Typography>{t('link-error-7')}</Typography>
        </Box>
      </ContentWithLogoGrid>
    </View>
  )
}

export default NotFoundView
